/* eslint-disable @typescript-eslint/no-explicit-any */
import { create } from 'zustand'
import { MutableRefObject } from 'react'

// Tipo para o objeto PDF carregado
export type PDFSource = {
  uri: string
  cache?: boolean
  method?: string
  headers?: Record<string, string>
  expiration?: number
}

interface IPDFState {
  url: string | null
  isLoaded: boolean
  numberOfPages: number
  currentPage: number
  error: string | null
  pdfRef: MutableRefObject<any> | null
  pdfSource: PDFSource | null
  setUrl: (url: string) => void
  setIsLoaded: (isLoaded: boolean) => void
  setNumberOfPages: (numberOfPages: number) => void
  setCurrentPage: (currentPage: number) => void
  setError: (error: string | null) => void
  setPdfRef: (ref: MutableRefObject<any>) => void
  setPdfSource: (source: PDFSource) => void
  resetState: () => void
}

const initialState = {
  url: null,
  isLoaded: false,
  numberOfPages: 0,
  currentPage: 1,
  error: null,
  pdfRef: null,
  pdfSource: null,
}

export const usePdfStore = create<IPDFState>((set) => ({
  ...initialState,
  setUrl: (url) => set({ url }),
  setIsLoaded: (isLoaded) => set({ isLoaded }),
  setNumberOfPages: (numberOfPages) => set({ numberOfPages }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setError: (error) => set({ error }),
  setPdfRef: (pdfRef) => set({ pdfRef }),
  setPdfSource: (pdfSource) => set({ pdfSource }),
  resetState: () => set(initialState),
}))
